function consultAnalyticsOptions() {
  const target = document.querySelector('#consult_scheduling')

  if (!target) return

  const apiPath = target.dataset.analyticsPath
  const resourceName = 'consult_analytics'

  const params = {
    order_id: target.dataset.orderId,
    requisition_number: target.dataset.requisitionNumber
  }

  return {
    target,
    options: {
      apiPath,
      resourceName,
      params
    }
  }
}

export default consultAnalyticsOptions